(function () {
  if (window.__validOptionsLoaded) return;
  window.__validOptionsLoaded = true;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
    var variants = p.variants.map(function (v) { return v.options.map(String); });
    function init() {
      var root = document.querySelector('variant-selects');
      if (!root) return;
      var busy = false;
      function sels() { return Array.prototype.slice.call(root.querySelectorAll('select')); }
      function exists(prefix) {
        return variants.some(function (v) {
          for (var i = 0; i < prefix.length; i++) if (v[i] !== prefix[i]) return false;
          return true;
        });
      }
      function refresh(fire) {
        var s = sels();
        if (s.length !== (variants[0] || []).length) return;
        var cur = [];
        var changed = false;
        for (var i = 0; i < s.length; i++) {
          var opts = Array.prototype.slice.call(s[i].options);
          var first = null;
          opts.forEach(function (o) {
            var ok = exists(cur.concat([o.value]));
            o.disabled = !ok;
            o.hidden = !ok;
            if (ok && first === null) first = o.value;
          });
          var val = s[i].value;
          if (!exists(cur.concat([val])) && first !== null) {
            s[i].value = first;
            val = first;
            changed = true;
          }
          cur.push(val);
        }
        if (changed && fire) {
          busy = true;
          var last = s[s.length - 1];
          last.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(function () { busy = false; }, 50);
        }
      }
      root.addEventListener('change', function () { if (!busy) refresh(false); }, true);
      refresh(true);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  }).catch(function () {});
})();
